import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import * as mixins from '../../../helpers/styles_mixins';
import { TypographyNavLink } from '../../atoms/TypographyNavLink';

const LinkExpansionPanel = styled(Link)`
    display: flex;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    min-height: 75px;
    transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    text-decoration: none;
    align-items: center;
    font-size: 16dpx;
    font-weight: 600;
    padding: ${mixins.setSizes([12, 24])};
    background-color: #ffffff;
    color: #4a4a4a;
`;

const NavLink = ({ texto, temFilhos, expanded, ...props }) => (
    <LinkExpansionPanel
        {...props}
        getProps={({ isCurrent }) => {
            // the object returned here is passed to the
            // anchor element's props
            if (isCurrent) {
                return {
                    style: {
                        backgroundColor: '#f5f5f5',
                        color: '#000000'
                    }
                };
            }
            return {};
        }}
    >
        <TypographyNavLink>{texto}</TypographyNavLink>
        {temFilhos && (
            <IconButton>
                <ExpandMoreIcon />
            </IconButton>
        )}
    </LinkExpansionPanel>
);

NavLink.propTypes = {
    texto: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
    temFilhos: PropTypes.bool
};

NavLink.defaultProps = {
    temFilhos: false,
    expanded: false
};

export { NavLink };
